import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import AtAGlance from "./components/AtAGlance";
import Expertise from "./components/Expertise";
import SurgicalExpertise from "./components/SurgicalExpertise";
import Stats from "./components/Stats";
import Timeline from "./components/Timeline";
import Journey from "./components/Journey";
import Organizations from "./components/Organizations";
import Research from "./components/Research";
import Awards from "./components/Awards";
import Leadership from "./components/Leadership";
import Philosophy from "./components/Philosophy";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const Home = () => (
  <div className="App bg-white">
    <Header />
    <main>
      <Hero />
      <AtAGlance />
      <Expertise />
      <SurgicalExpertise />
      <Stats />
      <Timeline />
      <Journey />
      <Organizations />
      <Research />
      <Awards />
      <Leadership />
      <Philosophy />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
